<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="公告内容"
                    prop="texts">
        <el-input v-model="dataForm.texts"
                  placeholder="公告内容"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary"
                 @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: 0,
        texts: ''
      },
      dataRule: {
        texts: [
          { required: true, message: '公告内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.$http({
          url: this.global.apiUrl + `/jxjg/jggonggao/info/${this.dataForm.id}`,
          method: 'get',
          params: {
            'id': this.dataForm.id
          }
        }).then((data) => {
          data = data.body
          if (data && data.code === 0) {
            this.dataForm.texts = data.jggonggao.texts
          }
        })
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jggonggao/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            params: {
              'id': this.dataForm.id || undefined,
              'texts': this.dataForm.texts
            }
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jggonggao-add-or-update.vue